/* eslint-disable no-unneeded-ternary */
/* eslint-disable react/no-unstable-nested-components */
import React from 'react';
import { Box, Button } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { DataGrid } from '../../components/datagrid';
import { SearchFilter } from '../../components/inputs/filters/search';
import { PageTitle } from '../../components/PageTitle';
import { useFetch } from '../../hooks/useFetch';
import { getArrayItems, getCellImage } from '../../utils/FormatFunctions';
import { useAuth } from '../../providers/auth';

export function ResponsiblePage() {
  const baseApiUrl = '/v1/admin';
  const baseUrl = `${baseApiUrl}/users?group_id=5`;
  const { requestApi, data, loading, error } = useFetch(baseUrl);
  const { user } = useAuth();
  const navigate = useNavigate();
  const groupIds = user?.group?.id;

  const columns = [
    { name: 'id', label: 'Id' },
    { name: 'image', label: 'Imagem' },
    { name: 'name', label: 'Nome' },
    { name: 'email', label: 'Email' },
    { name: 'childrens', label: 'Filhos' },
  ];

  return (
    <Box>
      <PageTitle>Responsáveis</PageTitle>

      <DataGrid
        columns={columns}
        rows={data?.data}
        requestApi={requestApi}
        error={error}
        baseUrl={baseUrl}
        data={data}
        hasCreate={groupIds !== 3 ? true : false}
        loading={loading}
        rowActions={{ show: false, edit: true, delete: true }}
        columnWithAction={[
          {
            name: 'childrens',
            columnAction: rowItem => (
              <Button
                textTransform="uppercase"
                colorScheme="button.primary"
                onClick={() => navigate(`${rowItem.id}`)}
              >
                Ver filhos
              </Button>
            ),
          },
        ]}
        formatColum={[
          {
            field: 'image',
            formatField: values => getCellImage(values, true),
          },
          {
            field: 'institutions',
            formatField: getArrayItems,
          },
        ]}
        headerFilters={[
          {
            name: 'search',
            filterComponent: SearchFilter,
          },
        ]}
      />
    </Box>
  );
}
